import { TRANSFER_STATUS_VALUE } from '@app/shared/types/enums/transfer-status.enum';
import { DURING_EVENT_TRANSFER_AUTO_COMPLETE_SETTING } from '@app/shared/types/ui/xux-grid/xux-grid.type';
import { DUPLICATE_TRANSFER_ERROR_KEY } from '@app/shared/types/entities/transfer/transfer.enums';
import { I18n } from '@app/i18n/strings-keys';
import { IPdfColumn } from '@app/shared/common/make-pdf/v2';
import { TRANSFER_PDF_HEADER_VALUES } from '@app/shared/types';

export const apiItemFields: string[] = [
  '_id',
  'gl_account_entity_id',
  'gl_account_name',
  'item_entity_id',
  'item_name',
  'major_category_entity_id',
  'major_category_name',
  'major_category_external_id',
  'minor_category_entity_id',
  'minor_category_name',
  'minor_category_external_id',
  'measure_code',
  'measure_description',
  'measure_entity_id',
  'measure_factor_value',
  'measure_id',
];

/**
 * @deprecated Use I18n.EntityNames.DepartmentCode instead
 */
export const DEPARTMENT_CODE = 'Department Code';
/**
 * @deprecated Use I18n instead
 */
export const DEPARTMENT_CODE_NOT_CONFIGURED = 'Not Configured';

export const VISIBLE_TRANSFER_GRID_ROW_COUNT = 5;
export const VISIBLE_TRANSFER_DESTINATION_GRID_ROW_COUNT = 10;

export const UPDATE_STATUS_MSG_MAPPING: Partial<{
  [key in TRANSFER_STATUS_VALUE]: { action: string; did?: string };
}> = {
  [TRANSFER_STATUS_VALUE.Pending]: {
    action: I18n.Common.submit,
    did: I18n.Status.submitted,
  },
  [TRANSFER_STATUS_VALUE.Completed]: {
    action: I18n.Common.accept,
  },
  [TRANSFER_STATUS_VALUE.Rejected]: {
    action: I18n.Common.reject,
  },
};

export const AUTO_COMPLETE =
  DURING_EVENT_TRANSFER_AUTO_COMPLETE_SETTING.AUTO_COMPLETE;
export const NOT_AUTO_COMPLETE =
  DURING_EVENT_TRANSFER_AUTO_COMPLETE_SETTING.NOT_AUTO_COMPLETE;
export const AUTO_RESTOCK = 'auto-restock';

export const TRANSFER_REPLENISH_DEFAULT_PERCENT = 100;
export const OPEN_AND_PENDING_STATUS: TRANSFER_STATUS_VALUE[] = [
  TRANSFER_STATUS_VALUE.Open,
  TRANSFER_STATUS_VALUE.Pending,
];
export const CHANGE_STATUS_TOTAL_STEPS = 2;

export const REPLENISH_ITEM_OPTIONS = I18n.Forms.ReplenishForm.ItemOptions;

export const CLEAR_QTY = I18n.Forms.TransferForm.ClearQty;
export const CLEAR_QTY_REQUESTED = I18n.Forms.TransferForm.ClearQtyRequested;
export const CLEAR_QTY_RECEIVED = I18n.Forms.TransferForm.ClearQtyReceived;

export const DUPLICATE_TRANSFER_ERROR_OPTIONS = {
  [DUPLICATE_TRANSFER_ERROR_KEY.ITEM_NOT_ASSIGN_SITE]: {
    text: I18n.ErrorMessages.NotAssignedToSelectSites,
    value: DUPLICATE_TRANSFER_ERROR_KEY.ITEM_NOT_ASSIGN_SITE,
  },
  [DUPLICATE_TRANSFER_ERROR_KEY.ITEM_NOT_EXIST]: {
    text: I18n.ErrorMessages.ItemNotExist,
    value: DUPLICATE_TRANSFER_ERROR_KEY.ITEM_NOT_EXIST,
  },
  [DUPLICATE_TRANSFER_ERROR_KEY.ITEM_TRANSFER_UNIT_NOT_EXIST]: {
    text: I18n.ErrorMessages.TransferUnitNotExist,
    value: DUPLICATE_TRANSFER_ERROR_KEY.ITEM_TRANSFER_UNIT_NOT_EXIST,
  },
};

export const QTY_PULLED_COLUMN_DEFINE: IPdfColumn = {
  title: I18n.Forms.TransferForm.QtyPulled,
  path: TRANSFER_PDF_HEADER_VALUES.QtyPulled,
};
